import { render, staticRenderFns } from "./AngularDevelopment.vue?vue&type=template&id=fe2baaba&"
import script from "./AngularDevelopment.vue?vue&type=script&lang=js&"
export * from "./AngularDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports